export const YOUTUBE_VIDEO_ID = 'vsRf07uC6DM';

export type Chapter = {
  start: number; // seconds
  end: number; // seconds
  title: {
    ru: string;
    en: string;
  };
};

export const VIDEO_CHAPTERS: Chapter[] = [
  {
    start: 0,
    end: 220,
    title: {
      ru: 'вступление и контекст выпуска',
      en: 'intro & episode context',
    },
  },
  {
    start: 220,
    end: 615,
    title: {
      ru: 'LLM как новый способ думать по умолчанию',
      en: 'LLM as the new default thinking layer',
    },
  },
  {
    start: 615,
    end: 1110,
    title: {
      ru: 'почему AI «из коробки» почти не раскрывает потенциал',
      en: 'why “out-of-the-box” AI barely unlocks the value',
    },
  },
  {
    start: 1110,
    end: 1730,
    title: {
      ru: 'IFS: работа с частями личности простыми словами',
      en: 'IFS: parts work in plain language',
    },
  },
  {
    start: 1730,
    end: 2530,
    title: {
      ru: 'как соединить IFS и LLM на практике',
      en: 'how to combine IFS + LLM in practice',
    },
  },
  {
    start: 2530,
    end: 3330,
    title: {
      ru: 'AI как усилитель коучинга и терапии',
      en: 'AI as an amplifier for coaching & therapy',
    },
  },
  {
    start: 3330,
    end: 3900,
    title: {
      ru: 'философия Be Your Own Guru',
      en: 'the “Be Your Own Guru” philosophy',
    },
  },
  {
    start: 3900,
    end: 4628,
    title: {
      ru: 'вопросы и ответы',
      en: 'Q&A',
    },
  },
];


